import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { bannerList } from "@/mocks/banners";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = bannerList.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const goTo = (index: number) => setActive((index + total) % total);

  return (
    <section className="relative w-full overflow-hidden rounded-lg bg-foreground-950">
      <div className="relative h-[440px] w-full md:h-[560px]">
        {bannerList.map((banner, index) => {
          const href =
            banner.linkType === "special" ? `/special/${banner.linkId}` : `/detail/${banner.linkId}`;
          return (
            <div
              key={banner.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                index === active ? "opacity-100" : "pointer-events-none opacity-0"
              }`}
            >
              <img
                src={banner.image}
                alt={`${banner.title} 焦点推荐主视觉`}
                title={`${banner.title} ${banner.tag}`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/20"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-12">
                <div className="max-w-xl">
                  <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                    <i className="ri-fire-line"></i>
                    {banner.tag}
                  </span>
                  <h1 className="text-3xl font-bold text-background-50 md:text-5xl">
                    {banner.title}
                  </h1>
                  <p className="mt-3 text-sm text-background-100/90 md:text-base">
                    {banner.subtitle}
                  </p>
                  <Link
                    to={href}
                    className="mt-6 inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    立即查看
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button
        type="button"
        onClick={() => goTo(active - 1)}
        className="absolute left-4 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:left-6 md:h-11 md:w-11"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        onClick={() => goTo(active + 1)}
        className="absolute right-4 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:right-6 md:h-11 md:w-11"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 items-center gap-2">
        {bannerList.map((banner, index) => (
          <button
            key={banner.id}
            type="button"
            onClick={() => goTo(index)}
            className={`h-2 cursor-pointer rounded-full transition-all ${
              index === active ? "w-7 bg-primary-400" : "w-2 bg-background-50/60"
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          ></button>
        ))}
      </div>
    </section>
  );
}